angular.module('permanentUnitModule').component('permanentUnitHistorySection', {
    templateUrl: 'permanentUnitHistorySection/permanentUnitHistorySection.html',
    bindings: {
        section: '<',
        mobileMode: '@',
        showLatestOnly: '@',
    },
    controller: ['PubSub', '$http', '$timeout', '$sce', '$compile', 'StateService', 'gVariables', 'crResourcesService', 'ImageService',
        function (PubSub, $http, $timeout, $sce, $compile, StateService, gVariables, crResourcesService, ImageService) {
            var ctrl = this;
            ctrl.$onInit = function() {
                this.listingBlimps = [];
                ctrl.currentTab = null;
                ctrl.showReadMore = false;
                ctrl.isGuest = G;

                $timeout(function () {
                    if (ctrl.section) {
                        ctrl.section.listingSlides = [];
                        if (ctrl.section.images) {
                            ctrl.section.images.forEach(function (image) {
                                let processedImage = ImageService.getSmartImage(217, 136, image, 'smart');
                                ctrl.section.listingSlides.push(processedImage);
                            });
                        }
                    }
                    
                    // Initialize registration buttons after DOM is ready
                    $timeout(function() {
                        var regButtons = document.querySelectorAll('permanent-unit-history-section .reg_blimp');
                        regButtons.forEach(function(btn) {
                            var event = document.createEvent("HTMLEvents");
                            event.initEvent("addRegLink", true, true);
                            event.eventEl = btn;
                            document.dispatchEvent(event);
                        });
                    }, 100);
                }, 300);
            };

            ctrl.openListingGalleryPopup = (event, listingId, display = 'gallery') => {
                event.stopPropagation();

                // CITY-5489: the permanent-unit page now serves the neo (desktop)
                // template to phones, where mobileMode isn't set — gate on the
                // viewport so the Blimp popup (not mobile friendly) never opens.
                // Navigate to the listing instead when we have a url.
                if (ctrl.mobileMode === 'true' || window.innerWidth < 1023) {
                    if (ctrl.section && ctrl.section.listingUrl) {
                        window.location.href = ctrl.section.listingUrl;
                    }
                    return;
                }

                // Check if BlimpExtV2 is available (may not be loaded on mobile)
                if (typeof BlimpExtV2 === 'undefined') {
                    // Fallback to direct navigation if Blimp is not available
                    if (ctrl.section.listingUrl) {
                        window.location.href = ctrl.section.listingUrl;
                    }
                    return;
                }
                
                // Desktop behavior - open popup
                let link = event.target.closest('.price_history_listing_gallery_link');

                if (!!listingId && !!this.listingBlimps[listingId]) {
                    this.listingBlimps[listingId].handle_link_click();
                    this.listingBlimps[listingId].show_widget(display);
                    if (this.listingBlimps[listingId].pagePhotogallery && this.listingBlimps[listingId].pagePhotogallery.pg && this.listingBlimps[listingId].pagePhotogallery.pg.current_index) {
                        this.listingBlimps[listingId].pagePhotogallery.pg.scrollMainToPosition(this.listingBlimps[listingId].pagePhotogallery.pg.current_index);
                    }
                } else if (!!listingId && !this.listingBlimps[listingId]) {
                    this.listingBlimps[listingId] = new BlimpExtV2(link, {
                        cache: true,
                        draggable: true,
                        show_veil: false,
                        fullscreen: true,
                        display: display,
                        onPostRpc: function () {
                            this.add_extra(true);
                            Core.compile_html(this._element);
                        }
                    });
                    this.listingBlimps[listingId].handle_link_click();
                }
            };

            ctrl.showImagesTab = () => {
                ctrl.currentTab = 'images';
            }

            ctrl.showDescriptionTab = () => {
                ctrl.currentTab = 'description';
                $timeout(function () {
                    ctrl.checkDescriptionHeight();
                });
            }

            ctrl.expandDescription = function () {
                ctrl.showReadMore = !ctrl.showReadMore;
            }


            ctrl.checkDescriptionHeight = function() {
                let descriptionElement = document.querySelector('permanent-unit-history-section .listing-description');
                if (descriptionElement) {
                    if (descriptionElement.scrollHeight <= 150) {
                        ctrl.showReadMore = false;
                    } else {
                        ctrl.showReadMore = true;
                    }
                }
            }

            function add_blimp_edits() {
                let _edits = document.querySelectorAll('permanent-unit-history-section .w_blimp_edit');
                _edits.forEach(function(_edit) {
                    new Blimp.Form(_edit, { draggable: true, put_others_behind: true });
                });
            }
            $timeout(function () {
                add_blimp_edits();
            }, 300);
        }
    ]
});